import { RolexContainer } from './Container'
import { Image } from '@components/gassan-ui'
import { SecondaryCta } from '@components/rolex-ui/SecondaryCta'
import { Text } from '@components/rolex-ui/Text'
import { getKontentImage } from '@lib/kontent'
import { RolexProductPageV72024 } from '@lib/kontent/models/RolexProductPageV72024'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type RolexProductPropertiesProps = RolexProductPageV72024

export const RolexProductProperties: FC<RolexProductPropertiesProps> = ({
  specifications_reference,
  specifications_model_case,
  specifications_bezel,
  specifications_water_resistance,
  specifications_movement,
  specifications_calibre,
  specifications_power_reserve,
  specifications_bracelet,
  specifications_dial,
  specifications_certification,
  specifications_image,
  link_to_brochure,
  title,
}) => {
  const { t } = useTranslation('rolex')
  const reference = specifications_reference.value.toString()
  const modelCase = specifications_model_case.value
  const bezel = specifications_bezel.value
  const waterResistance = specifications_water_resistance.value
  const movement = specifications_movement.value
  const calibre = specifications_calibre.value
  const powerReserve = specifications_power_reserve.value
  const bracelet = specifications_bracelet.value
  const dial = specifications_dial.value
  const certification = specifications_certification.value

  return (
    <div className="bg-rolexBeige py-[30px] md:py-[90px]">
      <RolexContainer className="grid grid-rows-2 gap-2 lg:grid-cols-[3fr_2fr] lg:grid-rows-1 lg:items-center">
        <div className="row-start-2 lg:row-start-1">
          <div className="mb-8 columns-2 gap-4 border-b border-solid border-rolexBrown/20 pb-8 md:mb-10 md:gap-10 md:pb-10">
            {reference && <Item title={t('specs.reference')}>{reference}</Item>}
            {modelCase && <Item title={t('specs.modelCase')}>{modelCase}</Item>}
            {bezel && <Item title={t('specs.bezel')}>{bezel}</Item>}
            {waterResistance && <Item title={t('specs.waterResistance')}>{waterResistance}</Item>}
            {movement && <Item title={t('specs.movement')}>{movement}</Item>}
            {calibre && <Item title={t('specs.calibre')}>{calibre}</Item>}
            {powerReserve && <Item title={t('specs.powerReserve')}>{powerReserve}</Item>}
            {bracelet && <Item title={t('specs.bracelet')}>{bracelet}</Item>}
            {dial && <Item title={t('specs.dial')}>{dial}</Item>}
            {certification && <Item title={t('specs.certification')}>{certification}</Item>}
          </div>
          {link_to_brochure && (
            <SecondaryCta
              as="link"
              href={link_to_brochure.value}
              target="_blank"
              iconLeft="download"
            >
              Download brochure
            </SecondaryCta>
          )}
        </div>
        <div className="row-start-1 mx-auto w-full max-w-[500px]">
          <Image
            sources={[768, 1024].map((width) =>
              getKontentImage(specifications_image?.value[0]?.url, { width }),
            )}
            loading="lazy"
            alt={title.value}
            className="aspect-square"
          />
        </div>
      </RolexContainer>
    </div>
  )
}

const Item: FC<{ title: string }> = ({ title, children }) => (
  <div className="mb-4 break-inside-avoid-column">
    <Text variant="body20">{title}</Text>
    <Text variant="body20" weight="light">
      {children}
    </Text>
  </div>
)
